export default "__VITE_ASSET__Uek_5UJG__"